// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + {"356":"foundation","498":"offcanvas"}[chunkId] + ".js";
};